import React, { useState } from "react";
import { getDataFromConfig } from "../../../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";
import "./kpiConfigDataSummaryButtonsSelect.css";
import "../configureKPICommon.css";
interface KPIConfigDataSummaryButtonsSelectProps {
  kpi: any;
  updateUserConfig: (_id: string, _kpi: Record<string, any>) => void;
  defaultConfigGlobal : Record<string,any>;
}
const KPIConfigDataSummaryButtonsSelect: React.FC<
  KPIConfigDataSummaryButtonsSelectProps
> = ({ kpi, updateUserConfig,defaultConfigGlobal }) => {
  const defaultConfigButtonsList = getDataFromConfig(
    "KPI_summary_buttons",
    kpi.id,defaultConfigGlobal
  );
  const userConfigButtonsList = kpi.buttons || [];
  const [selectedButtons, setSelectedButtons] = useState<string[]>(
    userConfigButtonsList.map((button: any) => button.id)
  );

  const handleCheckboxChange = (id: string) => {
    const isSelected = selectedButtons.includes(id);

    const updatedSelectedButtons = isSelected
      ? selectedButtons.filter((buttonId) => buttonId !== id)
      : [...selectedButtons, id];

    setSelectedButtons(updatedSelectedButtons);

    const newButtons = defaultConfigButtonsList.reduce(
      (acc: Record<string, any>[], button: Record<string, any>) => {
        if (updatedSelectedButtons.includes(button.id)) {
          acc.push(button);
        }
        return acc;
      },
      []
    );
    const newKPI = { ...kpi, buttons: newButtons };
    updateUserConfig(kpi.id, newKPI);
  };
// console.log("buttons rendered")
  return defaultConfigButtonsList.length > 0 ? (
    <div>
      <div className="kpi-label-title">
        Select filters you wish to add for displaying summary
      </div>
      <div className="kpi-config-data-summary-buttons-container">
        {defaultConfigButtonsList.map((button: any) => (
          <div
            key={button.id + kpi.id}
            className="kpi-config-data-summary-button-container"
          >
            <div>
              <div className="kpi-config-data-summary-button-checkbox-container">
                <input
                  type="checkbox"
                  id={`kpi-config-data-summary-button-checkbox-${button.id+kpi.id}`}
                  checked={selectedButtons.includes(button.id)}
                  onChange={() => handleCheckboxChange(button.id)}
                  className="kpi-config-data-summary-button-checkbox"
                />
                <label
                  htmlFor={`kpi-config-data-summary-button-checkbox-${button.id+kpi.id}`}
                  className="kpi-config-data-summary-button-label"
                ></label>
              </div>
            </div>
            <div className="kpi-config-data-summary-button-saved-label">{button.label}</div>{" "}
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default KPIConfigDataSummaryButtonsSelect;
